import React from "react";
import { FormConfiguration } from "../../FormConfiguration";
import { FormRuntime } from "../../FormRuntime";
import { SwitchFormControl } from "../Web/SwitchFormControl";
import { XStackContainer } from "../../Containers";
import { StoryNode } from "../../../CommonUI/StoryBook/StoryData";

function getUI(): { form: FormConfiguration; control: SwitchFormControl } {
    let ui = new FormConfiguration();
    let container = new XStackContainer();

    ui.add(container);

    let switchField = new SwitchFormControl();
    switchField.label = "Switch Field Label";
    switchField.valueName = "value";
    switchField.requiredOnAllOutcomes = false;
    container.add(switchField);

    return { form: ui, control: switchField };
}

export const SwitchStories = [
    new StoryNode(
        () => {
            let ui = getUI();
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Switch",
        "Default"
    ),
    new StoryNode(
        () => {
            let ui = getUI();
            ui.control.label = "Default As True";
            ui.control.defaultValue = true;
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Switch",
        "Default Value As True"
    ),
];
